(function () {
  if (!location.pathname.includes("/products/viaim-recdot")) return;

  var flowClass = "viaim-recdot-flow";
  var hiddenClass = "viaim-hidden-selection";
  var data = {
    Black: {
      base: {
        free: ["47529280864502", 229.00, 229.00, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/recdot-earbuds_2.png?v=1784879367"],
        pro: ["51009541472502", 289.00, 308.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/recdot_-pro-black_1a28d165-a1fe-4430-b0eb-bb028814f969.png?v=1782141968"],
        ultra: ["51009541505270", 349.00, 388.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/recdot_-ultra-black_1ce614b6-8daa-4035-b2d5-6eece7d39001.png?v=1782141965"]
      },
      noteKit: {
        free: ["50548636090614", 279.00, 300.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/9-removebg-preview_dc31d98b-6ebb-4fa0-a8ce-25348d8510c2.png?v=1770359539"],
        pro: ["51495624769782", 339.00, 380.98, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/prorecdotsbundle.png?v=1781317362"],
        ultra: ["51495624802550", 409.00, 460.98, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/ultrarecdotsbundle-2.png?v=1781317433"]
      }
    },
    Silver: {
      base: {
        free: ["50548636123382", 229.00, 229.00, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/recdot_sliver.jpg?v=1770359539"],
        pro: ["51009541538038", 289.00, 308.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/recdot_-pro-sliver_6d97b41b-ee07-4562-89d2-58c7140da394.png?v=1782141970"],
        ultra: ["51009541570806", 349.00, 388.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/recdot_-ultra-sliver_0661dc45-47b7-43d1-97d1-1a2fabb17d6d.png?v=1782141964"]
      },
      noteKit: {
        free: ["50548636156150", 279.00, 300.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/10-removebg-preview_76b7c05b-aa67-4b75-8393-4099d64a0f13.png?v=1770359539"],
        pro: ["51495624835318", 339.00, 380.98, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/recdotslvbundle.png?v=1781316197"],
        ultra: ["51495624868086", 409.00, 460.98, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/ultrarecdotsbundle.png?v=1781317433"]
      }
    }
  };

  function normalizeVariantId(id) {
    return String(id || "").split("/").pop();
  }
  function liveProductVariants() {
    var node = document.querySelector("script[data-viaim-product-variants]");
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || "[]");
    } catch (error) {
      return [];
    }
  }
  function syncPricingFromShopify() {
    var live = liveProductVariants();
    if (!live.length) return;
    var byId = {};
    live.forEach(function (variant) {
      byId[normalizeVariantId(variant.id)] = variant;
    });
    for (var color in data) {
      for (var kit in data[color]) {
        for (var plan in data[color][kit]) {
          var item = data[color][kit][plan];
          var liveVariant = byId[normalizeVariantId(item[0])];
          if (!liveVariant) continue;
          if (liveVariant.price != null && liveVariant.price !== "") {
            item[1] = Number(liveVariant.price) / 100;
          }
          var compareAt = liveVariant.compare_at_price;
          item[2] = compareAt != null && compareAt !== "" ? Number(compareAt) / 100 : item[1];
          if (liveVariant.featured_image && liveVariant.featured_image.src) {
            item[3] = liveVariant.featured_image.src;
          }
        }
      }
    }
  }
  syncPricingFromShopify();
  var legacy = {
    "50757507023094": ["Black", false, "pro"],
    "50760443461878": ["Black", false, "ultra"],
    "50757507088630": ["Silver", false, "pro"],
    "50760443494646": ["Silver", false, "ultra"]
  };
  var colors = ["Black", "Silver"];
  var selections = [
    "RecDot",
    "RecDot + NoteKit",
    "RecDot + Annual Pro Plan",
    "RecDot + Annual Ultra Plan",
    "RecDot + NoteKit + Annual Pro Plan",
    "RecDot + NoteKit + Annual Ultra Plan"
  ];
  var state = stateFromVariant(new URLSearchParams(location.search).get("variant")) || { color: "Black", noteKit: false, plan: null };
  var timer = 0;

  var css = ".viaim-recdot-flow{margin:22px 0 18px;color:rgb(var(--color-foreground,29 29 31));font-family:inherit}.viaim-recdot-flow *{box-sizing:border-box}.vrs{padding:22px 0;border-top:1px solid rgba(var(--color-foreground,29 29 31),.13)}.vrs:first-child{border-top:0;padding-top:0}.vrh{font-size:21px;line-height:1.2;font-weight:500;margin:0 0 14px}.vrhint{font-size:14px;line-height:1.42;color:rgba(var(--color-foreground,29 29 31),.68);margin:-6px 0 14px}.vro{display:grid;gap:12px}.vro.color{grid-template-columns:repeat(2,minmax(0,1fr))}.vro.kit{grid-template-columns:1fr}.vrc{appearance:none;width:100%;text-align:left;border:1px solid #6e6e73;background:rgb(var(--color-background,255 255 255));border-radius:13px;padding:15px 18px;color:inherit;cursor:pointer;transition:border-color .16s ease,background .16s ease}.vrc[aria-pressed=true]{border-color:#f55f0c;background:linear-gradient(135deg,#fff 0%,rgba(245,95,12,.06) 100%)}.vrc.color{min-height:58px;display:flex;align-items:center}.vrc.color .t{font-size:16px;font-weight:400}.top{display:flex;align-items:flex-start;justify-content:space-between;gap:14px}.t{display:block;font-size:17px;font-weight:750;line-height:1.22}.txt{display:block;font-size:13.5px;line-height:1.4;color:rgba(var(--color-foreground,29 29 31),.72);margin-top:4px}.tag{display:inline-block;margin-top:8px;padding:4px 9px;border-radius:999px;background:rgba(245,95,12,.08);color:#d84f05;font-size:12px;font-weight:650;line-height:1}.pr{font-size:15px;font-weight:800;color:#f55f0c;white-space:nowrap}.dot{display:inline-block;width:16px;height:16px;border-radius:999px;border:1px solid rgba(var(--color-foreground,29 29 31),.18);box-shadow:inset 0 0 0 2px #fff;margin-right:10px;vertical-align:-2px}.dot.b{background:#000}.dot.s{background:#d5d5d5}.sum{display:none;margin-top:18px;padding:18px 20px;border-radius:18px;background:#f5f5f7;font-size:14px;line-height:1.42;align-items:center;justify-content:space-between;gap:14px}.sum.ready{display:flex}.sum small{display:block;margin-bottom:4px;font-size:12px;font-weight:750;color:#d84f05}.sum strong{font-weight:750}.sum .price{display:flex;flex-direction:column;align-items:flex-end;gap:2px;white-space:nowrap}.sum .was{font-size:14px;color:rgba(var(--color-foreground,29 29 31),.48);text-decoration:line-through}.sum .now{font-size:20px;font-weight:800;color:#f55f0c}.viaim-hidden-selection{display:none!important}@media(max-width:749px){.vro.color{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}.vrc{padding:15px}.vrc.color{min-height:54px;padding:13px 12px}.vrc.color .t{font-size:15px}.dot{margin-right:8px}.sum.ready{align-items:flex-start;flex-direction:column}.sum .price{align-items:flex-start}}";
  var extraCss = ".viaim-recdot-promo{margin:18px 0 18px;min-height:96px;border-radius:14px;padding:18px 20px;overflow:hidden;color:#fff;background:linear-gradient(110deg,rgba(23,23,23,.94) 0%,rgba(69,46,34,.9) 48%,rgba(245,95,12,.88) 100%);display:flex;flex-direction:column;justify-content:center;gap:4px}.viaim-recdot-promo span{font-size:12px;line-height:1.2;letter-spacing:.01em;opacity:.84}.viaim-recdot-promo strong{font-size:20px;line-height:1.15;font-weight:700}.viaim-recdot-promo em{font-size:13px;line-height:1.35;font-style:normal;opacity:.86}.viaim-feature-fold{position:relative}.viaim-feature-fold.is-collapsed .viaim-feature-preview{display:block;max-height:34px;overflow:hidden;opacity:.28;position:relative}.viaim-feature-fold.is-collapsed .viaim-feature-preview:after{content:\"\";position:absolute;inset:auto 0 0 0;height:24px;background:linear-gradient(180deg,rgba(var(--color-background,255 255 255),0),rgb(var(--color-background,255 255 255)))}.viaim-feature-fold.is-collapsed .viaim-feature-hidden{display:none}.viaim-feature-toggle{appearance:none;background:transparent;border:0;color:rgb(var(--color-foreground,29 29 31));cursor:pointer;display:flex;align-items:center;gap:8px;font:inherit;font-size:14px;line-height:1.2;margin:8px 0 0 auto;padding:8px 0;text-decoration:underline;text-underline-offset:3px}.viaim-feature-toggle:after{content:\"\";width:8px;height:8px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg);margin-top:-4px}.viaim-feature-toggle[aria-expanded=true]:after{transform:rotate(225deg);margin-top:4px}.viaim-feature-fold:not(.is-collapsed) .viaim-feature-preview{opacity:1;max-height:none}.viaim-feature-fold:not(.is-collapsed) .viaim-feature-hidden{display:block}@media(max-width:749px){.viaim-recdot-promo{min-height:82px;padding:15px 16px;border-radius:12px}.viaim-recdot-promo strong{font-size:17px}.viaim-recdot-promo em{font-size:12.5px}}";

  function stateFromVariant(id) {
    if (!id) return null;
    if (legacy[id]) return { color: legacy[id][0], noteKit: legacy[id][1], plan: legacy[id][2] };
    for (var color in data) {
      for (var kit in data[color]) {
        for (var plan in data[color][kit]) {
          if (data[color][kit][plan][0] === id) return { color: color, noteKit: kit === "noteKit", plan: plan };
        }
      }
    }
    return null;
  }
  function section() {
    var form = document.querySelector('main form[action*="/cart/add"]');
    return form && form.closest('[id^="shopify-section-"]') || document;
  }
  function kitKey() {
    return state.noteKit ? "noteKit" : "base";
  }
  function itemFor(kit, plan) {
    return data[state.color || "Black"][kit][plan || state.plan || "free"];
  }
  function variant(plan) {
    return itemFor(kitKey(), plan);
  }
  function selectedVariant() {
    return state.plan ? variant(state.plan) : null;
  }
  function forms(root) {
    return Array.prototype.slice.call(root.querySelectorAll('form[action*="/cart/add"]'));
  }
  function hasOption(node, values) {
    if (node.tagName === "SELECT") return Array.prototype.slice.call(node.options).some(function (option) { return values.indexOf(option.value) > -1; });
    return values.indexOf(node.value) > -1;
  }
  function nativeGroups(root) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll('input[type="radio"],select'));
    var groups = [];
    nodes.forEach(function (node) {
      if (!hasOption(node, colors) && !hasOption(node, selections)) return;
      var group = node.closest("fieldset") || node.closest(".product-form__input") || node.parentElement;
      if (group && groups.indexOf(group) < 0) groups.push(group);
    });
    return groups;
  }
  function hideNative(root) {
    nativeGroups(root).forEach(function (group) {
      group.classList.add(hiddenClass);
      group.setAttribute("aria-hidden", "true");
    });
  }
  function setFormVariant(root, item) {
    forms(root).forEach(function (form) {
      Array.prototype.slice.call(form.querySelectorAll('[name="id"]')).forEach(function (input) {
        input.value = item[0];
      });
    });
  }
  function setButton(root, item) {
    Array.prototype.slice.call(root.querySelectorAll('[name="add"],.product-form__submit,button[type="submit"]')).forEach(function (button) {
      button.textContent = item ? "Add to cart - $" + item[1].toFixed(2) : "Choose AI plan";
    });
  }
  function updateUrl(item) {
    if (!item || !history.replaceState) return;
    var url = new URL(location.href);
    url.searchParams.set("variant", item[0]);
    history.replaceState({}, "", url.toString());
  }
  function updateImage(root, item) {
    if (!item || !item[3]) return;
    var media = root.querySelector(".product__media:not([hidden])") || document.querySelector(".product__media");
    var img = media && media.querySelector("img") || document.querySelector(".product__media img");
    if (!img) return;
    Array.prototype.slice.call((img.closest("picture") || media || document).querySelectorAll("source")).forEach(function (source) {
      source.removeAttribute("srcset");
      source.removeAttribute("data-srcset");
    });
    img.removeAttribute("srcset");
    img.removeAttribute("data-src");
    img.removeAttribute("data-srcset");
    img.src = item[3];
    img.removeAttribute("sizes");
    img.loading = "eager";
    img.alt = "viaim RecDot " + state.color + " " + planName();
  }
  function money(item) {
    return "$" + item[1].toFixed(2);
  }
  function save(item) {
    var diff = Math.round((item[2] - item[1]) * 100) / 100;
    return diff > 0.99 ? "Save $" + diff.toFixed(2) : "";
  }
  function compactMoney(value) {
    var rounded = Math.round(Number(value) * 100) / 100;
    return "$" + (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2));
  }
  function updatePlanCards(el) {
    var freeItem = itemFor(kitKey(), "free");
    ["pro", "ultra"].forEach(function (plan) {
      var planItem = itemFor(kitKey(), plan);
      var price = el.querySelector('[data-plan-price="' + plan + '"]');
      var saving = el.querySelector('[data-plan-saving="' + plan + '"]');
      var diff = Math.max(0, Number(planItem[1]) - Number(freeItem[1]));
      if (price) price.textContent = "+" + compactMoney(diff) + "/year";
      if (saving) saving.textContent = save(planItem);
    });
  }
  function planName() {
    return state.plan === "pro" ? "Annual Pro" : state.plan === "ultra" ? "Annual Ultra" : state.plan === "free" ? "Free AI" : "AI plan not selected";
  }
  function bundleName() {
    return state.noteKit ? "RecDot + NoteKit" : "RecDot";
  }
  function findFeatureBlock(root) {
    var candidates = Array.prototype.slice.call(root.querySelectorAll(".product__info div,.product__description,.rte,[class*='description']"));
    candidates = candidates.filter(function (el) {
      var text = (el.textContent || "").replace(/\s+/g, " ");
      return text.indexOf("AI recorder + premium earbuds") > -1 && text.indexOf("FlashRecord:") > -1 && el.querySelectorAll("p").length > 3;
    });
    candidates.sort(function (a, b) {
      return b.querySelectorAll("p").length - a.querySelectorAll("p").length || (a.textContent || "").length - (b.textContent || "").length;
    });
    return candidates[0] || null;
  }
  function enhanceFeatures(root) {
    var block = findFeatureBlock(root);
    if (!block) return;
    Array.prototype.slice.call(root.querySelectorAll(".viaim-feature-toggle")).slice(1).forEach(function (toggle) {
      toggle.parentNode.removeChild(toggle);
    });
    if (block.classList.contains("viaim-feature-fold") && block.querySelector(".viaim-feature-toggle")) return;
    Array.prototype.slice.call(block.querySelectorAll(".viaim-feature-toggle")).forEach(function (toggle) {
      toggle.parentNode.removeChild(toggle);
    });
    var items = Array.prototype.slice.call(block.querySelectorAll("p")).filter(function (item) {
      return (item.textContent || "").trim();
    });
    if (items.length <= 3) return;
    block.classList.add("viaim-feature-fold", "is-collapsed");
    items.forEach(function (item) {
      item.classList.remove("viaim-feature-preview", "viaim-feature-hidden");
    });
    items.slice(3).forEach(function (item, index) {
      item.classList.add(index === 0 ? "viaim-feature-preview" : "viaim-feature-hidden");
    });
    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "viaim-feature-toggle";
    toggle.setAttribute("aria-expanded", "false");
    toggle.textContent = "View More";
    toggle.addEventListener("click", function () {
      var expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!expanded));
      toggle.textContent = expanded ? "View More" : "View Less";
      block.classList.toggle("is-collapsed", expanded);
    });
    block.appendChild(toggle);
  }
  function render(root, before) {
    var el = document.createElement("div");
    el.className = flowClass;
    el.innerHTML = '<div class="vrs"><h3 class="vrh">Choose your color</h3><div class="vro color"><button class="vrc color" type="button" data-color="Black"><span class="t"><span class="dot b"></span>Black</span></button><button class="vrc color" type="button" data-color="Silver"><span class="t"><span class="dot s"></span>Silver</span></button></div></div><div class="vrs"><h3 class="vrh">Add NoteKit to your setup?</h3><div class="vro kit"><button class="vrc" type="button" data-kit="base"><span class="top"><span><span class="t">RecDot only</span></span><span class="pr" data-kit-base-price>$229.00</span></span></button><button class="vrc" type="button" data-kit="noteKit"><span class="top"><span><span class="t">RecDot + NoteKit</span><span class="txt">A USB AI meeting recorder for your computer.</span><span class="tag" data-kit-saving>Save $21.99</span></span><span class="pr" data-kit-total>$279.00</span></span></button></div></div><div class="vrs"><h3 class="vrh">Choose your AI plan</h3><p class="vrhint">600 min/month included. Add an annual plan when you need more.</p><div class="vro"><button class="vrc" type="button" data-plan="free"><span class="top"><span><span class="t">Free</span><span class="txt">600 min/mo - Occasional recording</span></span><span class="pr">Included</span></span></button><button class="vrc" type="button" data-plan="pro"><span class="top"><span><span class="t">Annual Pro</span><span class="txt">1,800 min/mo - Best for frequent meetings</span><span class="tag" data-plan-saving="pro"></span></span><span class="pr" data-plan-price="pro"></span></span></button><button class="vrc" type="button" data-plan="ultra"><span class="top"><span><span class="t">Annual Ultra</span><span class="txt">Unlimited - Best for heavy daily use</span><span class="tag" data-plan-saving="ultra"></span></span><span class="pr" data-plan-price="ultra"></span></span></button></div></div><div class="sum" aria-live="polite"><span><small>Your selection</small><strong data-summary></strong><br><span data-note></span></span><span class="price" data-total></span></div>';
    before.parentNode.insertBefore(el, before);
    el.addEventListener("click", function (event) {
      var color = event.target.closest("[data-color]");
      var kit = event.target.closest("[data-kit]");
      var plan = event.target.closest("[data-plan]");
      if (color) state.color = color.getAttribute("data-color");
      if (kit) state.noteKit = kit.getAttribute("data-kit") === "noteKit";
      if (plan) state.plan = plan.getAttribute("data-plan");
      paint();
    });
  }
  function paint(prompt) {
    var root = section();
    var el = root.querySelector("." + flowClass);
    if (!el) return init();
    hideNative(root);
    Array.prototype.slice.call(el.querySelectorAll("[data-color]")).forEach(function (button) {
      button.setAttribute("aria-pressed", String(button.getAttribute("data-color") === state.color));
    });
    Array.prototype.slice.call(el.querySelectorAll("[data-kit]")).forEach(function (button) {
      button.setAttribute("aria-pressed", String((button.getAttribute("data-kit") === "noteKit") === state.noteKit));
    });
    Array.prototype.slice.call(el.querySelectorAll("[data-plan]")).forEach(function (button) {
      button.setAttribute("aria-pressed", String(button.getAttribute("data-plan") === state.plan));
    });
    var item = selectedVariant();
    var imageItem = item || variant("free");
    var displayPlan = state.plan || "free";
    var baseItem = itemFor("base", displayPlan);
    var kitItem = itemFor("noteKit", displayPlan);
    el.querySelector("[data-kit-base-price]").textContent = money(baseItem);
    el.querySelector("[data-kit-total]").textContent = money(kitItem);
    el.querySelector("[data-kit-saving]").textContent = save(kitItem);
    updatePlanCards(el);
    var summary = el.querySelector(".sum");
    el.querySelector("[data-summary]").textContent = bundleName() + " / " + state.color + " / " + planName();
    if (!item) {
      summary.classList.remove("ready");
      el.querySelector("[data-note]").textContent = prompt ? "Please choose an AI transcription option before adding to cart." : "Choose an AI transcription option to see your final total.";
      el.querySelector("[data-total]").textContent = "";
      setFormVariant(root, imageItem);
      setButton(root, null);
      updateImage(root, imageItem);
      updateUrl(imageItem);
      return;
    }
    summary.classList.add("ready");
    el.querySelector("[data-note]").textContent = save(item) || "Ready to add to cart.";
    el.querySelector("[data-total]").innerHTML = item[2] > item[1] ? '<span class="was">$' + item[2].toFixed(2) + '</span><span class="now">' + money(item) + '</span>' : '<span class="now">' + money(item) + '</span>';
    setFormVariant(root, item);
    setButton(root, item);
    updateImage(root, item);
    updateUrl(item);
  }
  function bind(root) {
    forms(root).forEach(function (form) {
      if (form.dataset.viaimBound) return;
      form.dataset.viaimBound = "1";
      form.addEventListener("submit", function (event) {
        var item = selectedVariant();
        if (!item) {
          event.preventDefault();
          event.stopImmediatePropagation();
          paint(true);
          return false;
        }
        setFormVariant(root, item);
      }, true);
    });
  }
  function addCss() {
    if (document.getElementById("viaim-recdot-flow-style")) return;
    var style = document.createElement("style");
    style.id = "viaim-recdot-flow-style";
    style.textContent = css + extraCss;
    document.head.appendChild(style);
  }
  function init() {
    addCss();
    var root = section();
    hideNative(root);
    bind(root);
    enhanceFeatures(root);
    if (!root.querySelector("." + flowClass)) {
      var groups = nativeGroups(root);
      if (!groups.length) return;
      render(root, groups[0]);
    }
    paint();
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var root = section();
      hideNative(root);
      bind(root);
      enhanceFeatures(root);
      if (!root.querySelector("." + flowClass)) init();
    }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
